import { Layout } from "@/components/layout";
import { DocumentList } from "@/components/documents/document-list";
import { useCurrentBusiness } from "@/hooks/use-businesses";
import { PageHeader } from "@/components/ui/page-header";
import { FileTextIcon } from "lucide-react";

export default function DocumentsPage() {
  const { currentBusiness } = useCurrentBusiness();

  return (
    <Layout>
      <div className="container py-6">
        <PageHeader
          title="Documents"
          description="Manage documents and receipts for your business"
          icon={<FileTextIcon className="h-6 w-6" />}
        />
        
        <div className="mt-6">
          <DocumentList />
        </div>
      </div>
    </Layout>
  );
}